import { type ReactNode } from 'react';
import { Text } from '@doist/marketist';
import cn from 'clsx';
import { ProductUISkeletonText } from '../product-ui-skeleton-text/product-ui-skeleton-text';
import css from './product-ui-tabs.module.css';
type ProductUITabsProps = {
  children: ReactNode;
};
function ProductUITabs({
  children
}: ProductUITabsProps) {
  return <div className={css.tabsContainer} data-sentry-component="ProductUITabs" data-sentry-source-file="product-ui-tabs.tsx">{children}</div>;
}
type ProductUITabsChoiceCommon = {
  icon?: ReactNode;
  selected?: boolean;
};
type ProductUITabsChoiceAbstracted = {
  children?: never;
  abstracted: true;
};
type ProductUITabsChoiceChildren = {
  children: ReactNode;
  abstracted?: never;
};
type ProductUITabsChoiceProps = ProductUITabsChoiceCommon & (ProductUITabsChoiceAbstracted | ProductUITabsChoiceChildren);
ProductUITabs.Choice = function ProductUITabChoice({
  icon,
  selected = false,
  children,
  abstracted,
  ...rest
}: ProductUITabsChoiceProps) {
  return <div className={cn(css.tabChoice, {
    [css.selected]: selected
  })} {...rest}>
            <div className={css.tabChoiceContent}>
                {icon ? <div className={css.iconContainer}>{icon}</div> : null}
                {abstracted ? <ProductUISkeletonText width="100" /> : <Text tag="span" size="minor-xs">
                        {children}
                    </Text>}
            </div>
        </div>;
};
export { ProductUITabs };